import * as React from "react";
import * as Article from "@elevio/kb-kit/lib/components/article";
import { getHeader, brandShowcaseUrl } from "./home";
import PageLayout from "../components/layouts/Page";
import Footer from "../components/Footer";
import WithAsideLayout, { Aside, Main, MainHeader, MainBody, } from "../components/layouts/WithAside";
import ArticleList from "../components/ArticleList";
import ArticleMeta from "../components/ArticleMeta";
import ArticleActions from "../components/ArticleActions";
import ArticleFeedback from "../components/ArticleFeedback";
function Page() {
    React.useEffect(() => {
        const ensureSubmitRequestLinksAreAccessible = () => {
            const links = document.querySelectorAll('.article-main-body a[href*="/submitRequest"]');
            links.forEach((link) => {
                var _a;
                const hasReadableText = (link.textContent || "").trim().length > 0;
                const hasAriaLabel = !!((_a = link.getAttribute("aria-label")) === null || _a === void 0 ? void 0 : _a.trim());
                if (!hasReadableText && !hasAriaLabel) {
                    link.setAttribute("aria-label", "Submit request");
                    link.setAttribute("title", "Submit request");
                }
            });
        };
        ensureSubmitRequestLinksAreAccessible();
        const observer = new MutationObserver(() => {
            ensureSubmitRequestLinksAreAccessible();
        });
        observer.observe(document.body, { childList: true, subtree: true });
        return () => observer.disconnect();
    }, []);
    return (<PageLayout header={getHeader()} footer={<Footer />}>
      <div className="ask-arvada-logo-wrapper">
        <img className="ask-arvada-logo" src={brandShowcaseUrl} alt="ask-agency-logo-wrapper-image"/>
      </div>
      <WithAsideLayout className="article-page">
        <Main>
          <MainHeader>
            <ArticleActions />
            <h1 className="main-title" data-testid="article-title">
              <Article.Title />
            </h1>
            <ArticleMeta />
          </MainHeader>

          <MainBody className="article-main-body">
            <Article.Body />
          </MainBody>
          <ArticleFeedback />
        </Main>

        <Aside>
          <ArticleList isRelated isAside/>
        </Aside>
      </WithAsideLayout>
    </PageLayout>);
}
export default Page;
